import type { Normalizer } from '../format'

export class AllNormalizer implements Normalizer {
  matches() {
    return true
  }

  normalize(input: string) {
    return [input]
  }
}
